module.exports = __webpack_public_path__ + "img/ico-financeiro.d0ca8eeb.svg";